import projection from '../generated/pwc516f1.json';
import { AcceptanceManifest } from '../types';

export const pwc516f1AcceptanceManifest = projection as AcceptanceManifest;
